import React from 'react';
import { Document } from '@react-pdf/renderer';
import { detect } from 'detect-browser';
import { Bereavement, CarePlanFrequency, CarePlanProblems, DocLink, Measures, ClearScripts, ProgressNotes, Facesheet, PatientAssistance } from '@mummssoftware/utils/constants';
import { CoversheetPDFComponent, CPFTablePDF, CarePlanProblemsPDF, ProgressNotesPDF, CertificationsPDF, MeasuresPDF, MedicationsPDF, BereavementPDF, PatientAssistancePDF, FacesheetPDF } from '../PDFComponents';
const browser = detect();
export const DashboardPDFDocument = ({
  pdfWeeklyTasks,
  includePdfTasksNotes,
  pdfTasksNotes,
  pdfFacesheetData,
  pdfCareGiversInfo,
  widgetConfig,
  patient,
  currentUser,
  rgHash,
  rgHashPrint,
  patientCertHistory,
  dashboardPrintConfig,
  cpfNotes,
  cppNotesGlobal,
  pdfCarePlanProblems,
  pdfProgressNotes,
  pdfPSOComponents,
  pdfMeasuresGraphImages,
  measuresGlobal,
  pdfMedications,
  pdfMedicationsNotes,
  pdfBereavNotes,
  pdfCertAppSnapshot,
  jsonMeasures,
  historicalRows,
  sourceString
}) => /*#__PURE__*/React.createElement(Document, null, patient && /*#__PURE__*/React.createElement(CoversheetPDFComponent, {
  patient: patient,
  browser: browser,
  patientCertHistory: patientCertHistory,
  siteTimezone: currentUser.siteTimezone,
  dashboardPrintConfig: dashboardPrintConfig,
  sourceString: sourceString
}), widgetConfig && widgetConfig.includes(Facesheet) && pdfFacesheetData && patient && /*#__PURE__*/React.createElement(FacesheetPDF, {
  browser: browser,
  patient: patient,
  dto: pdfFacesheetData
}), widgetConfig && widgetConfig.includes(Bereavement) && pdfCareGiversInfo && patient && /*#__PURE__*/React.createElement(BereavementPDF, {
  pdfCareGiversInfo: pdfCareGiversInfo,
  dashboardPrintConfig: dashboardPrintConfig,
  pdfBereavNotes: pdfBereavNotes,
  browser: browser,
  patient: patient
}), widgetConfig && widgetConfig.includes(CarePlanProblems) && pdfCarePlanProblems && patient && /*#__PURE__*/React.createElement(CarePlanProblemsPDF, {
  patient: patient,
  browser: browser,
  cppNotesGlobal: cppNotesGlobal,
  pdfCarePlanProblems: pdfCarePlanProblems,
  dashboardPrintConfig: dashboardPrintConfig
}), widgetConfig && widgetConfig.includes(CarePlanFrequency) && rgHash && rgHashPrint && patient && /*#__PURE__*/React.createElement(CPFTablePDF, {
  patient: patient,
  browser: browser,
  rgHash: rgHash,
  rgHashPrint: rgHashPrint,
  historicalRows: historicalRows,
  dashboardPrintConfig: dashboardPrintConfig,
  cpfNotes: cpfNotes
}), widgetConfig && widgetConfig.includes(PatientAssistance) && pdfWeeklyTasks && patient && /*#__PURE__*/React.createElement(PatientAssistancePDF, {
  patient: patient,
  browser: browser,
  pdfWeeklyTasks: pdfWeeklyTasks,
  includePdfTasksNotes: includePdfTasksNotes,
  pdfTasksNotes: pdfTasksNotes,
  dashboardPrintConfig: dashboardPrintConfig
}), widgetConfig && widgetConfig.includes(DocLink) && pdfCertAppSnapshot && patient && /*#__PURE__*/React.createElement(CertificationsPDF, {
  patient: patient,
  browser: browser,
  pdfCertAppSnapshot: pdfCertAppSnapshot,
  dashboardPrintConfig: dashboardPrintConfig
}), widgetConfig && widgetConfig.includes(Measures) && pdfMeasuresGraphImages && measuresGlobal && patient && /*#__PURE__*/React.createElement(MeasuresPDF, {
  patient: patient,
  browser: browser,
  pdfMeasuresGraphImages: pdfMeasuresGraphImages,
  dashboardPrintConfig: dashboardPrintConfig,
  measuresGlobal: measuresGlobal,
  jsonMeasures: jsonMeasures
}), widgetConfig && widgetConfig.includes(ClearScripts) && pdfMedications && patient && /*#__PURE__*/React.createElement(MedicationsPDF, {
  patient: patient,
  currentUser: currentUser,
  browser: browser,
  dashboardPrintConfig: dashboardPrintConfig,
  pdfMedications: pdfMedications,
  pdfMedicationsNotes: pdfMedicationsNotes
}), widgetConfig && widgetConfig.includes(ProgressNotes) && pdfProgressNotes && pdfPSOComponents && patient && /*#__PURE__*/React.createElement(ProgressNotesPDF, {
  patient: patient,
  browser: browser,
  dashboardPrintConfig: dashboardPrintConfig,
  pdfProgressNotes: pdfProgressNotes,
  pdfPSOComponents: pdfPSOComponents
}));